import { render, staticRenderFns } from "./DetailReport.vue?vue&type=template&id=0a9c1e1a&"
import script from "./DetailReport.vue?vue&type=script&lang=js&"
export * from "./DetailReport.vue?vue&type=script&lang=js&"
import style0 from "./DetailReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports